import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { HttpErrorResponse } from '@angular/common/http';
import { MatDialog } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { of } from 'rxjs';
import { catchError, switchMap } from 'rxjs/operators';
import { MatSnackBar } from '@angular/material/snack-bar';
import { DataResponseOrder } from '../../../../../../../../core/model/DataOrder';
import { CheckoutService } from '../../../../utils/services/checkout.service';
import { CartService } from '../../../../../../../../services/generar-pedido/cart/cart.service';
import { SwalService } from '../../../../../../../../services/swal/swal.service';
import { LoginService } from '../../../../../../../../services/login/login.service';
import { PedidoGeneradoComponent } from '../../../../pedido-generado/pedido-generado.component';

@Component({
  selector: 'app-efectivo',
  templateUrl: './efectivo.component.html',
  styleUrls: ['./efectivo.component.scss']
})
export class EfectivoComponent implements OnInit {
  @Output() clickSubmit: EventEmitter<boolean> = new EventEmitter<false>();
  @Input() loading: boolean;
  @Input() textoLoading: string;
  @Input() disabled: boolean;
  // public loading = false;
  public success = false;
  public banderaBtn = true; // en efectivo no puede comprar PG

  constructor(
    private service: CheckoutService,
    private cartService: CartService,
    private swal: SwalService,
    private router: Router,
    private login: LoginService,
    private matSnackBar: MatSnackBar,
    public pedidoGenDialog: MatDialog
  ) { }

  ngOnInit(): void {
    if (this.login.getDataClientePedido().es_publicogeneral === 'NO') {
      this.banderaBtn = false;
    }
  }

  // MÉTODO PARA REALIZAR EL PEDIDO
  public placeOrder = () => {
    if (this.login.isLogged()) {
      // este emiter es para enviar el emmiter del padre para desactivar los radioButton
      this.cartService.guardCheckout = true;
      this.clickSubmit.emit(true);
      this.loading = true;
      this.textoLoading = 'Generando pedido...'
      // return
      this.service.validarParidad()
        .pipe(
          catchError(error => this.handleError(error, 'paridad')),
          switchMap((response: any) => this.validParidad(response)))
        .pipe(
          catchError(error => this.handleError(error, 'pedido')),
        ).subscribe((responseDataOrder: DataResponseOrder) => this.validOrder(responseDataOrder));
    } else {
      this.matSnackBar.open('Tu sesión ha expirado. Vuelve a iniciar sesión', 'Ok', {
        duration: 10000,
        horizontalPosition: 'center',
      });
      this.router.navigate(['iniciar_session/login']);
    }
  }

  /*################################*/
  /* MÉTODO PARA VALIDAR LA RESPUESTA DE LA PARIDAD Y SI EL TIPO DE CABIO ESTÁ CORRECTO */
  /*################################*/
  public validParidad = (response) => {
    if (response.status) { // si la paridad exite enviamos la peticion del pedido
      return this.service.placeOrder(localStorage.getItem('tipo-pago')); // ejecutamos la peticion del pedido
    } else { // si no entonces no enviamos la peticion y le mandamos null al siguiente subscribe y mandamos un mensaje de error
      this.loading = false;
      this.clickSubmit.emit(false);  // habilitamo de nuevo los radioButton
      // this.swal.swalError('Ocurrio un error!', 'Lo sentimos, tenemos inconvenientes para generar el pedido, intente más tarde.');
      return of(null);
    }
  }

  /*################################*/
  /* MÉTODO PARA VALIDAR LA RESPUESTA DE LA PETICIÓN DEL PEDIDO */
  /*################################*/
  public validOrder = (responseDataOrder: DataResponseOrder) => {
    const cliente = this.login.getDataClientePedido();
    if (responseDataOrder) {
      if (responseDataOrder.error === false) {
        // console.log('respose order',responseDataOrder);
        localStorage.setItem('data-pedido', JSON.stringify(responseDataOrder));
        this.success = true;
        const tpPago = localStorage.getItem('tipo-pago');
        const pedidoSucursal = Object.keys(responseDataOrder.pedidoSucursal).length === 0 ? 0 : responseDataOrder.pedidoSucursal.pedidoId;
        const pedidoCedis = Object.keys(responseDataOrder.pedidoCedis).length === 0 ? 0 : responseDataOrder.pedidoCedis.pedidoId;
        this.clickSubmit.emit(false);
        console.log('localStorage.getItem)', localStorage.getItem('items-cart-login'))
        console.log(pedidoSucursal, pedidoCedis, tpPago)
        this.openPedidoGenerado(pedidoSucursal, pedidoCedis, tpPago);
        if (responseDataOrder.condicionado) {
          this.swal.swalAlert(
            '¡Pedido condicionado!',
            '' + responseDataOrder.message +
            '<br/><br/><div style="font-size: 14px;"><p>Número de cliente: ' + cliente.client_number + '<br/>Nombre: ' + cliente.company_name + '<br/>Correo electrónico: ' + cliente.email + '<br/>Almacén: ' + cliente.almacenPre + '</p></div>'
          );
        }
        // this.cartService.destroyCart();
        console.log('localStoragedestroyCart', localStorage.getItem('items-cart-login'))
      } else {
        this.swal.swalAlert(
          '¡Upps!',
          'Lo sentimos, ocurrio un error al generar el pedido<br/><br/>Error: ' + responseDataOrder.message +
          '<br/><br/><div style="font-size: 14px;"><p>Número de cliente: ' + cliente.client_number + '<br/>Nombre: ' + cliente.company_name + '<br/>Correo electrónico: ' + cliente.email + '<br/>Almacén: ' + cliente.almacenPre + '</p></div>'
        );
        this.clickSubmit.emit(false);
      }
    }
    this.loading = false;
  }

  openPedidoGenerado(pedidoSucursal: any, pedidoCedis: any, tpPago: string): void {
    this.pedidoGenDialog.open(PedidoGeneradoComponent, {
      width: '2800px',
      panelClass: 'search-product',
      disableClose: true,
      data: {
        pedidoSucursal,
        pedidoCedis,
        tipoPago: 'efectivo',
        tpPago
      }
    })
  }

  /*################################*/
  /* MÉTODO PARA MANDAR EL ERROR */
  /*################################*/
  private handleError = (error: HttpErrorResponse | any, to: string) => {
    const cliente = this.login.getDataClientePedido();
    this.clickSubmit.emit(false);
    switch (to) {
      case 'paridad':
        this.swal.swalError('Generar pedido', 'Lo sentimos, estamos experimentando problemas en el sitio, por favor comunícate con el administrador de este sitio.<br/><br/>Error: ' + error.message +
          '<br/><br/><div style="font-size: 14px;"><p>Número de cliente: ' + cliente.client_number + '<br/>Nombre: ' + cliente.company_name + '<br/>Correo electrónico: ' + cliente.email + '<br/>Almacén: ' + cliente.almacenPre + '</p></div>');
        return of(error);
      case 'pedido':
        this.swal.swalError('Generar pedido', 'Lo sentimos, tenemos inconvenientes para generar el pedido, comunícate con el administrador del sitio o intente más tarde.<br/><br/>Error: ' + error.message +
          '<br/><br/><div style="font-size: 14px;"><p>Número de cliente: ' + cliente.client_number + '<br/>Nombre: ' + cliente.company_name + '<br/>Correo electrónico: ' + cliente.email + '<br/>Almacén: ' + cliente.almacenPre + '</p></div>');
        return of(error);
    }
  }
}
